import _ from 'lodash'

import { TOOL } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: TOOL,
  params: {},
  needFetchFillInfo: false,
  formatData(data) {
    if (data.toolDeployRange) {
      data.toolDeployRange = data.toolDeployRange.join(',')
    }
    if (data.toolCategory) {
      data.toolCategory = data.toolCategory.join(',')
    }
    return data
  },
  view: {
    title: '创建工具',
    labelPosition: 'right',
    labelWidth: '160px',
    width: '700px',
    content: [
      {
        $id: 'toolName',
        $type: 'input',
        label: '程序名称',
        $el: {
          placeholder: '请输入程序名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '程序名称'
          }
        ]
      },
      {
        $id: 'toolVersion',
        $type: 'input',
        label: '工具版本',
        $el: {
          placeholder: '请输入工具版本',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '工具版本'
          }
        ]
      },
      {
        $id: 'toolDesc',
        $type: 'input',
        label: '工具名称',
        $el: {
          placeholder: '请输入工具名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '工具名称'
          }
        ]
      },
      {
        $id: 'toolDetail',
        $type: 'input',
        label: '工具用途',
        $el: {
          placeholder: '请输入工具用途',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: '工具用途'
          }
        ]
      },
      {
        $id: 'toolScene',
        $type: 'input',
        label: '使用场景',
        $el: {
          placeholder: '请输入使用场景',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: '使用场景'
          }
        ]
      },
      {
        $id: 'toolLogoBase64',
        $type: 'input',
        label: '工具Logo',
        $el: {
          placeholder: '请输入工具Logo Base64 ,格式： data:image/png;base64,iVBORw0K...',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: '工具Logo'
          }
        ]
      },
      {
        $id: 'provideMode',
        $type: 'radio-group',
        label: '工具下载方式',
        $default: null,
        tip: {
          label: '备注：使用防盗链接须先将软件上传CDN，并获得原始地址，下载时会动态生成下载地址；普通链接则直接下载'
        },
        $options: [
          {
            label: '防盗链接',
            value: 'PROTECTION'
          },
          {
            label: '普通连接',
            value: 'NORMAL'
          }
        ],
        rules: [
          {
            notEmpty: '工具下载方式'
          }
        ]
      },
      {
        $id: 'toolUrl',
        $type: 'input',
        label: '下载地址',
        $el: {
          placeholder: '请输入下载地址',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: '下载地址'
          }
        ]
      },
      {
        $id: 'toolGuide',
        $type: 'input',
        label: '使用指南',
        $el: {
          placeholder: '请输入使用指南文档链接，如：https(http)://aa.ruijie.com.cn/1',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'toolFaq',
        $type: 'input',
        label: '常见问题',
        $el: {
          placeholder: '请输入常见问题文档链接，如：https(http)://aa.ruijie.com.cn/1',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'toolChecksum',
        $type: 'input',
        label: '文件摘要',
        $el: {
          placeholder: '请输入文件摘要(MD5)',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '文件摘要'
          }
        ]
      },
      {
        $id: 'toolProvider',
        $type: 'input',
        label: '工具提供者',
        $el: {
          placeholder: '请输入工具提供者',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '工具提供者'
          }
        ]
      },
      {
        $id: 'toolCategory',
        $type: 'select',
        label: '工具类型',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $options: [
          {
            label: '售前测试',
            value: 'POC'
          },
          {
            label: '交付部署',
            value: 'PSC'
          },
          {
            label: '客户运营',
            value: 'OPERATION'
          },
          {
            label: 'Halo工具商店',
            value: 'HALO'
          },
          {
            label: '其它工具',
            value: 'OTHERS'
          }
        ],
        rules: [
          {
            notEmpty: '工具类型'
          }
        ],
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.value,
              label: item.label
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        }
      },
      {
        $id: 'toolDeployRange',
        $type: 'select',
        label: '发布范围',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $options: [
          {
            label: 'Halo工具箱',
            value: 'HALO'
          },
          {
            label: '小锐工具箱',
            value: 'RUI'
          },
          {
            label: '运营平台',
            value: 'WSP'
          }
        ],
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.value,
              label: item.label
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        },
        rules: [
          {
            notEmpty: '发布范围'
          }
        ]
      },
      {
        $id: 'toolStatus',
        $type: 'select',
        label: '工具状态',
        $options: [
          {
            label: '上架',
            value: 'ON_SHELF'
          },
          {
            label: '下架',
            value: 'OFF_SHELF'
          }
        ],
        rules: [
          {
            notEmpty: '工具状态'
          }
        ]
      }
    ]
  }
}
